import React, {Component} from "react";

class NotificationCategory extends Component {
    render() {
        const { category } = this.props;
        let icon = "";
        switch(category) {
            case "artigio":
                icon = (<i className="fas fa-check-circle mr-2"/>);
                break;
            case "software-update-success":
                icon = (<i className="fas fa-thumbs-up mr-2 text-success"/>)
                break;
            case "HiLightSoftwareUpdate":
                icon = (<i className="fas fa-thumbs-down mr-2 text-danger"/> )
                break;
            default :
                icon = (<i className="fas fa-info-circle mr-2"/>);
                break;
        }

        return (icon);
    }
}
export default NotificationCategory;